// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin_registration_button {
  display: flex;
  flex-wrap: wrap;
  padding: 35px;
}
.add_supervisor {
  padding: 15px 25px;
  background-color: #e05f2c;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/addEmployes/employee.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".admin_registration_button {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 35px;\n}\n.add_supervisor {\n  padding: 15px 25px;\n  background-color: #e05f2c;\n  border-radius: 10px;\n  color: white;\n  font-weight: 700;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
